import { AssertionException } from '../utils/log';

type Success<T> = {
  value: T;
  success: true;
};

type FailWithError<TError> = {
  success: false;
  failureReason: TError;
};

export type TryWithError<T, TError> = Success<T> | FailWithError<TError>;
export type Try<T> = TryWithError<T, void>;

export const createUnsuccessfulAttempt = <T>(): Try<T> => ({
  success: false,
  failureReason: undefined,
});

export const createUnsuccessfulAttemptWithError = <T, TError>(error: TError): TryWithError<T, TError> => ({
  success: false,
  failureReason: error,
});

export const createSuccessfulAttempt = <T, TError = void>(value: T): TryWithError<T, TError> => ({
  success: true,
  value,
});

export function ensureSuccess<T>(result: Try<T>): asserts result is Success<T> {
  if (!result.success) {
    throw AssertionException('Unexpected fail');
  }
}
